import lararstiftelsenLogo from "./forms/0048/logo.png";

export default {
  oes: {
    active: true,
    requisition: true,
    bankId: true,
    hideDeadLine: true,
    login: { bankid: true, usernamepassword: true },
  },
  handelsradet: { active: true },
  demo: {
    active: true,
    login: { bankid: true, usernamepassword: true },
    requisition: true,
  },
  tystaskolan: { active: true, requisition: true, requistionSinceDate: new Date("2025-09-01") },
  ljungbergsstiftelsen: { active: true },
  kempe: { active: true },
  irisforvaltning: { active: true },
  japanstiftelsen: {
    active: true,
    login: { bankid: true, usernamepassword: true },
  },
  nok: { active: true, requisition: true },
  hff: { active: true },
  ostersjostiftelsen: {
    active: true,
    login: { usernamepassword: true, bankid: true },
  },
  langmanska: {
    active: true,
    requisition: true,
    reqV1: false,
    reqStartSessionId: 432
  },
  jjss: {
    active: true,
    requisition: true,
    login: { usernamepassword: true, bankid: true },
  },
  armfelt: { active: true },
  kungligapatriotiskasallskapet: {
    active: true,
    requisition: true,
    reqV1: false,
    reqStartSessionId: 658,
    login: { bankid: true },
  },
  hrf: { active: true },
  bf: { active: true },
  regionsormland: { active: true },
  regionuppsala: { active: true },
  sph: { active: true },
  sjomanshus: { active: true },
  annaochedwinberger: { active: true },
  villasanmichele: { active: true },
  pso: { active: true },
  regionvastmanland: { active: true, applicationSessionPrefix: true },
  konstakademien: {
    active: true,
    requisition: true,
    reqStartSessionId: 8,
    reqV1: false,
  },
  idkort: {
    active: true,
    login: { bankid: true, usernamepassword: true },
  },
  cmlerici: { active: true },
  uppsalakommun: { active: true },
  test101: { active: true, login: { bankid: true, usernamepassword: true } },
  lararstiftelsen: {
    active: true,
    login: { bankid: true },
    color: "#ffdd9b",
    navClass: "navbar-light",
    logoSrc: lararstiftelsenLogo,
    requisition: true,
  },
  ekhagastiftelsen: {
    active: true,
    login: { bankid: true, usernamepassword: true },
  },
  sjsf: { active: true, requisition: true, reqStartSessionId: 623 },
  sjf: {
    active: true,
    requisition: true,
    reqStartSessionId: 686,
    login: { bankid: true, usernamepassword: true },
  },
  kma: {
    active: true,
    requisition: true,
    login: { bankid: true, usernamepassword: true },
  },
  norrskenmind: {
    active: true,
    login: { bankid: false, usernamepassword: true },
  },
  almsstiftelse: {
    active: true,
    requisition: true,
    login: { bankid: false, usernamepassword: true },
  },
  vitterhetsakademien: {
    active: true,
    requisition: true,
    requistionSinceDate: new Date("2024-01-01"),
    login: { bankid: true, usernamepassword: true },
  },
  aner: {
    active: true,
    login: { usernamepassword: true },
  },
  svenstenback: {
    active: true,
    requisition: true,
    login: { bankid: true, usernamepassword: false },
  },
  lantbruksakademien: {
    active: true,
    requisition: true,
    login: { bankid: true, usernamepassword: true },
  },
  mag: {
    active: true,
    login: { usernamepassword: true },
  },
  ics: {
    active: false,
    login: { usernamepassword: true },
  },
  svenskaakademien: {
    active: true,
    requisition: true,
    login: { bankid: true, usernamepassword: true },
  },
  "svenskaakademien-priser": {
    active: true,
    requisition: true,
    login: { usernamepassword: true, bankid: true },
  },
  "svenskaakademien-nominering": {
    active: true,
    login: { usernamepassword: true },
  },
  tomtabarnhem: {
    active: true,
    login: { usernamepassword: true },
  },
  sts: {
    active: true,
    login: { usernamepassword: true, bankid: true },
    requisition: true,
  },
  oejvetstift: {
    active: true,
    requisition: true,
    login: { bankid: true, usernamepassword: true },
  },
  ics2026: {
  active: true,
  login: { usernamepassword: true },
  },
  sfub: {
  active: true,
  requisition: true,
  login: { bankid: true },
  },
  regionvarmland: {
  active: false,
  requisition: true,
  login: { usernamepassword: true },
  },
  enblomska: {
  active: true,
  requisition: false,
  login: { usernamepassword: true },
  },
};
